<h4 class="p-2 pl-4 mb-4 text-white" mat-dialog-title>&nbsp;{{data.title}}</h4>
<mat-dialog-content class="sen-fs10 pb-2">
    <p>{{translate.getLng('VARIETY_PROFILE_INFO')}}</p>
    <table mat-table class="w-100 mt-3 table" [dataSource]="dataSource">
        <ng-container matColumnDef="hProfileName">
            <th mat-header-cell *matHeaderCellDef> {{translate.getLng('VARIETY_PROFILE_TH1')}}</th>
            <td mat-cell *matCellDef="let element">
                <div style="display: inline-block; padding: 2px;"
                    [style.color]="element.description?.includes('XXL') ? 'white' : 'black'"
                    [style.background-color]="element.description?.includes('XXL') ? 'green' : 'yellow'">
                    {{element.description}} ({{element.hProfileName}})</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>
                &nbsp;
            </th>
            <td mat-cell *matCellDef="let element sen-fs12" style="position: relative;">
                <mat-icon matSuffix
                    style="color: white; font-size: 18px; position: absolute;right: 1px; top: 5px;">done</mat-icon>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr [ngClass]="{'sen-menu-blue-bg ': row.hProfileName == hProfileName }" mat-row class="sen-cursor-pointer"
            (click)="setHProfile(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <p>{{translate.getLng('color_code_explanation')}}</p>
</mat-dialog-content>
<!-- <mat-dialog-actions class="text-center justify-content-end"> -->
<div style="text-align: right;">
    <button mat-raised-button color="primary" class="sen-fs10 px-4 "
        (click)="onClick()">{{data.buttons.cancel}}</button>
</div>
<!-- </mat-dialog-actions> -->